// import * as yup from "yup";
// import {dobValidationSchemaFactory} from "../../../utils/yupSchemaUtils";

import {
  allottedTimeFactory,
  CM_SERVICES_20_MINS_MINIMUM_MONTH,
  PHQ_OR_GAD_96127,
  timeSlotArray,
} from "../../../ScheduleAvailability/constants";
import { transformTimeSlotArray } from "../../../ScheduleAvailability/ScheduleEvent";

export const CARE_COORDINATION_CALL_FOCUS_OPTIONS = {
  Medical: false,
  Medication: false,
  "Member Engagement": false,
  Other: false,
  SDoH: false,
  SUD: false,
  "Suicide Ideations/Crisis": false,
  "Symptom Management": false,
};

export const CARE_COORDINATION_SCHEMA = [
  {
    elementClasses: "col-12 col-lg-2",
    elementConfig: {
      label: "Call Started At",
      placeholder: "01/01/2020",
      type: "text",
    },
    elementType: "input",
    name: "session_date",
  },
  {
    elementClasses: "col-12 col-lg-1",
    elementConfig: {
      label: "",
      options: transformTimeSlotArray(timeSlotArray),
      placeholder: "12:00 pm",
      sentenceCase: false,
    },
    elementType: "select",
    name: "session_from",
  },
  {
    elementClasses: "col-9",
    elementConfig: {
      label: "CPT Description",
      options: [
        {
          display: `99484: CM Services; min 20 mins minimum/calendar month (${allottedTimeFactory(
            CM_SERVICES_20_MINS_MINIMUM_MONTH,
          )} minutes)`,
          value: CM_SERVICES_20_MINS_MINIMUM_MONTH,
        },
        { display: "96127: PHQ or GAD", value: PHQ_OR_GAD_96127 },
      ],
      placeholder: "Select",
    },
    elementType: "select",
    name: "call_type",
  },
  {
    elementClasses: "col-12",
    elementConfig: {
      label: "Purpose of Call",
      options: [
        { display: "Monthly", value: "Monthly" },
        { display: "Referral", value: "Referral" },
        { display: "Clinical Team Meeting", value: "Clinical Team Meeting" },
        { display: "PHQ9", value: "PHQ9" },
        { display: "PCP Coordination", value: "PCP Coordination" },
        { display: "Other", value: "Other" },
      ],
      placeholder: "Select",
    },
    elementType: "select",
    name: "content.purpose_of_call",
  },
  {
    elementClasses: "col-12",
    elementConfig: {
      label: "Additional Information",
      placeholder: "Type comment...",
      type: "textArea",
    },
    elementType: "textarea",
    name: "content.additional_information",
  },
  {
    elementClasses: "col-12 col-lg-2",
    elementConfig: {
      label: "Call Outcome",
      options: [
        { display: "Attempted", value: "Attempted" },
        { display: "Completed", value: "Completed" },
      ],
      placeholder: "Select",
    },
    elementType: "select",
    name: "content.call_outcome",
  },
  {
    elementClasses: "col-12 col-lg-9",
    elementConfig: {
      label: "Plan",
      options: [
        { display: "Call Monthly", value: "Call Monthly" },
        { display: "Prescriber Consult", value: "Prescriber Consult" },
        { display: "PCP Consult", value: "PCP Consult" },
        { display: "Clinical Team Meeting", value: "Clinical Team Meeting" },
        { display: "Other", value: "Other" },
      ],
      placeholder: "Select",
    },
    elementType: "select",
    name: "content.plan",
  },
  {
    elementClasses: "col-12",
    elementConfig: {
      label: "Call Focus",
      options: CARE_COORDINATION_CALL_FOCUS_OPTIONS,
      placeholder: "",
      type: "checkbox",
    },
    elementType: "input",
    name: "content.call_focus",
  },
  {
    elementClasses: "col-12 col-lg-7",
    elementConfig: {
      label: "Patient Assessment",
      placeholder: "",
      type: "text",
    },
    elementType: "input",
    name: "content.patient_outcome_answer",
  },
  {
    elementConfig: {
      label: "",
      placeholder: "",
    },
    elementType: "discharges",
    name: "content.discharges",
  },
  {
    elementClasses: "col-12 col-lg-6",
    elementConfig: {
      label: "ICD-10 Primary Diagnosis",
      options: [],
      placeholder: "",
    },
    elementType: "reactselect",
    name: "ICD_10_axis_1_diagnosis",
  },
  {
    elementClasses: "col-12 col-lg-6",
    elementConfig: {
      label: "ICD-10 Secondary Diagnosis",
      options: [],
      placeholder: "",
    },
    elementType: "reactselect",
    name: "ICD_10_axis_2_diagnosis",
  },
  {
    elementClasses: "col-12 col-lg-7",
    elementConfig: {
      classNames: "font-weight-bold",
      displayName: "Click to Sign",
      hideTopLabel: true,
      label: "Signature",
      type: "checkbox",
    },
    elementType: "input",
    name: "signature",
  },
  {
    elementClasses: "col-12 col-lg-3",
    elementConfig: {
      label: "Credentials",
      placeholder: "",
      type: "text",
    },
    elementType: "input",
    name: "provider_cp_credentials",
  },
];
